document.addEventListener('DOMContentLoaded', function() {
  
     // All functionality is disabled in this version
    // The code is left in place to easily enable when more languages are added
    
    // To enable the dropdown in the future:
    // 1. Remove the 'disabled' class from the selected-language div
    // 2. Uncomment the language options in the HTML
    // 3. Uncomment the JavaScript script <script src="{{ 'footer-section.js' | asset_url }}" defer="defer"></script>
   
/*    const selectedLanguage = document.getElementById('selected-language');
    const languageDropdown = document.getElementById('language-dropdown');
    const languageOptions = document.querySelectorAll('.language-option');

    // Set initial selected language based on current URL
    function setInitialLanguage() {
      const currentPath = window.location.pathname;
      let currentLang = 'en'; // Default language
      
      // Check URL for language code
      if (currentPath.startsWith('/fr/')) {
        currentLang = 'fr';
      } else if (currentPath.startsWith('/es/')) {
        currentLang = 'es';
      }
      // Add other language checks as needed
      
      // Find and set the current language display
      const currentOption = document.querySelector(`.language-option[data-lang="${currentLang}"]`);
      if (currentOption) {
        const flagImg = currentOption.querySelector('svg').src;
        const langText = currentOption.querySelector('span').textContent;
        
        selectedLanguage.querySelector('svg').src = flagImg;
        selectedLanguage.querySelector('span').textContent = langText;
      }
    }
    
    // Call to set initial language on page load
    setInitialLanguage();
    
    // Toggle dropdown
    selectedLanguage.addEventListener('click', function() {
      languageDropdown.classList.toggle('active');
      selectedLanguage.classList.toggle('active');
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(event) {
      if (!selectedLanguage.contains(event.target) && !languageDropdown.contains(event.target)) {
        languageDropdown.classList.remove('active');
        selectedLanguage.classList.remove('active');
      }
    });
    
    // Language selection and URL redirection
    languageOptions.forEach(option => {
      option.addEventListener('click', function() {
        const lang = this.getAttribute('data-lang');
        const flagImg = this.querySelector('svg').cloneNode(true);
        const langText = this.querySelector('span').textContent;
        
        // Update the selected language display
        selectedLanguage.querySelector('svg').src = flagImg.src;
        selectedLanguage.querySelector('span').textContent = langText;
        
        // Close the dropdown
        languageDropdown.classList.remove('active');
        selectedLanguage.classList.remove('active');
        
        // Here you would typically redirect to the selected language version
        // You can implement Shopify's language switching logic here
        // For example:
        // window.location.href = '/'+lang;

        // Implement Shopify language switching logic
        redirectToLocalizedUrl(lang);
        
      });
    });

   // Function to handle URL redirection
    function redirectToLocalizedUrl(lang) {
      // Get current path and extract components
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split('/').filter(part => part);
      let newPath = '';
      
      // Check if first part is a language code
      const knownLangCodes = ['fr', 'en', 'es']; // Add all your language codes here
      const firstPartIsLang = pathParts.length > 0 && knownLangCodes.includes(pathParts[0]);
      
      if (lang === 'en') {
        // For English (default language), remove the language prefix if exists
        if (firstPartIsLang) {
          newPath = '/' + pathParts.slice(1).join('/');
        } else {
          newPath = currentPath; // Already in English
        }
      } else {
        // For other languages
        if (firstPartIsLang) {
          // Replace existing language code
          pathParts[0] = lang;
          newPath = '/' + pathParts.join('/');
        } else {
          // Add language code
          newPath = '/' + lang + currentPath;
        }
      }
      
      // Add query parameters if any exist
      if (window.location.search) {
        newPath += window.location.search;
      }
      
      // Redirect to new URL
      window.location.href = newPath;
    }
*/

//Newsletter Subscription Validation
/*function isInputEmpty(inputValue) {
  // Trim whitespace and check if the trimmed value is empty
  return inputValue.trim() === '';
}

const form = document.getElementById('ContactFooter');
const submitButton = document.getElementById('Subscribe');

submitButton.addEventListener('click', function () {
  const inputElement = document.querySelector('.field__input_subscribe');
  const inputValue = inputElement.value;

  if (isInputEmpty(inputValue)) {
    inputElement.classList.add('invalid');
  } else {
    inputElement.classList.remove('invalid');
    form.submit();
  }
});*/


 //Newsletter Subscription Validation
  function isInputEmpty(inputValue) {
    // Trim whitespace and check if the trimmed value is empty
    return inputValue.trim() === '';
  }

  const form = document.getElementById('ContactFooter');
  const submitButton = document.getElementById('Subscribe');
  const inputElement = document.querySelector('.field__input_subscribe');
  
  // Check if we're on a success page by looking for the success message
  function checkForSuccessMessage() {
    const successMessage = document.getElementById('ContactFooter-success');
    
    if (successMessage) {
      // Hide the default Shopify success message
      successMessage.style.display = 'none';
      
      // Extract email from the success message text or try other methods
      let emailToUse = '';
      
      // Method 1: Check if input has value (Shopify sometimes preserves it)
      if (inputElement && inputElement.value) {
        emailToUse = inputElement.value;
      }
      
      // Method 2: Check URL for email parameter
      if (!emailToUse) {
        const urlParams = new URLSearchParams(window.location.search);
        emailToUse = urlParams.get('email') || urlParams.get('contact%5Bemail%5D') || urlParams.get('contact[email]');
      }
      
      // Method 3: Look for email in success message text
      if (!emailToUse) {
        const successText = successMessage.textContent;
        const emailMatch = successText.match(/[\w\.-]+@[\w\.-]+\.\w+/);
        if (emailMatch) {
          emailToUse = emailMatch[0];
        }
      }
      
      // Method 4: Check sessionStorage as backup (if it works in your environment)
      if (!emailToUse) {
        try {
          emailToUse = sessionStorage.getItem('newsletter_email') || '';
          sessionStorage.removeItem('newsletter_email');
        } catch(e) {
          // SessionStorage not available, continue
        }
      }
      
      handleSubscriptionSuccess(emailToUse);
    }
  }

  // Handle subscription success
  function handleSubscriptionSuccess(email) {
    const messageSuccess = document.querySelector('.message-success');
    const messageInitial = document.querySelector('.message-initial');
    const subscribeButton = document.getElementById('Subscribe');
    
    // Show success message, hide initial message
    if (messageSuccess) {
      messageSuccess.style.display = 'flex';
    }
    if (messageInitial) {
      messageInitial.style.display = 'none';
    }
    
    // Add green-success class to button
    if (subscribeButton) {
      subscribeButton.classList.add('green-success');
    }
    
    // Set the subscribed email in the input field
    if (inputElement) {
      if (email) {
        inputElement.value = email;
        inputElement.setAttribute('value', email);
      } else {
        // If no email found, show a generic success message
        console.log('Success detected but email not found');
      }
    }
    
    console.log('Subscription success with email:', email || 'email not captured');
  }

  // Store email before submission
  function storeEmailBeforeSubmit(email) {
    try {
      // Try to store in sessionStorage if available
      sessionStorage.setItem('newsletter_email', email);
    } catch(e) {
      // If sessionStorage fails, try to append to URL or use other method
      console.log('Could not store email, sessionStorage not available');
    }
  }

  // Submit button click handler
  if (submitButton) {
    submitButton.addEventListener('click', function () {
      const inputValue = inputElement.value;
      if (isInputEmpty(inputValue)) {
        inputElement.classList.add('invalid');
      } else {
        inputElement.classList.remove('invalid');
        
        // Store the email before form submission
        storeEmailBeforeSubmit(inputValue);
        
        form.submit();
      }
    });
  }

  // Check for success state on page load
  checkForSuccessMessage();

  // Also listen for form submission to detect success after redirect
  if (form) {
    // Check if page was loaded due to form submission success
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('customer_posted') || window.location.hash.includes('ContactFooter')) {
      // Delay check to ensure DOM is ready
      setTimeout(checkForSuccessMessage, 100);
    }
  }  


//Mobile Functionality for accordion slide up /down
  // Function to handle accordion functionality
  function setupFooterAccordion() {
    // Get all accordion headers
    const accordionHeaders = document.querySelectorAll('.accordian-header');
    
    // Check if we need to enable accordion (window width < 853px)
    const shouldEnableAccordion = window.innerWidth < 853;
    
    // Process each accordion header
    accordionHeaders.forEach((header, index) => {
      const footerBlock = header.closest('.footer-block');
      const chevron = header.querySelector('.chevron-down');
      const content = footerBlock.querySelector('.accordian-inner');
      
      // For desktop view
      if (!shouldEnableAccordion) {
        // For desktop: always expanded and visible
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        content.style.display = 'block'; // Ensure it's visible
        
        // Hide chevron on desktop
        if (chevron) {
          chevron.style.display = 'none';
        }
        
        // Remove click listeners if they exist
        header.removeEventListener('click', toggleAccordion);
        return; // Skip the rest of the code for desktop view
      }
      
      // For mobile view (< 853px)
      // Make header clickable
      header.style.cursor = 'pointer';
      
      // Show chevron on mobile
      if (chevron) {
        chevron.style.display = 'block';
      }
      
      // Set initial state - only first accordion open, all others closed
      if (index === 0) {
        // First accordion - open
        content.style.display = 'block';
        content.style.maxHeight = content.scrollHeight + 'px';
        if (chevron) chevron.style.transform = 'rotate(180deg)';
      } else {
        // All other accordions - closed
        content.style.maxHeight = '0';
        content.style.display = 'none'; // Explicitly hide
        if (chevron) chevron.style.transform = 'rotate(0deg)';
      }
      
      // Add click listener to the header
      header.addEventListener('click', toggleAccordion);
      
      // Toggle function for accordion
      function toggleAccordion() {
        const isOpen = content.style.display !== 'none';
        
        if (isOpen) {
          // Close accordion
          content.style.maxHeight = '0';
          setTimeout(() => {
            content.style.display = 'none';
          }, 300); // Match transition duration
          if (chevron) chevron.style.transform = 'rotate(0deg)';
        } else {
          // Open accordion - first make it visible, then animate height
          content.style.display = 'block';
          // Force a reflow to make the transition work
          content.offsetHeight;
          content.style.maxHeight = content.scrollHeight + 'px';
          if (chevron) chevron.style.transform = 'rotate(180deg)';
        }
      }
    });
  }
  
  // Initial setup
  setupFooterAccordion();
  
  // Re-run setup on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupFooterAccordion, 250); // Debounce resize event
  });
  
});